import { useEffect } from 'react'

import { authApi } from '@/api/auth'
import { useAuthStore } from '@/stores/authStore'

/**
 * Επαναφέρει τη συνεδρία στο άνοιγμα της εφαρμογής.
 *
 * Το access token ζει μόνο στη μνήμη, οπότε μετά από ανανέωση σελίδας χάνεται.
 * Το httpOnly refresh cookie όμως επιβιώνει και μια κλήση `/auth/refresh` το
 * ανταλλάσσει με νέα συνεδρία. Η αποτυχία είναι φυσιολογική: σημαίνει απλώς
 * ότι ο επισκέπτης δεν είναι συνδεδεμένος.
 */
export function useBootstrapSession() {
  const setSession = useAuthStore((s) => s.setSession)
  const setBootstrapped = useAuthStore((s) => s.setBootstrapped)

  useEffect(() => {
    let cancelled = false

    authApi
      .refresh()
      .then((session) => {
        if (!cancelled) setSession(session)
      })
      .catch(() => {
        if (!cancelled) setSession(null)
      })
      .finally(() => {
        if (!cancelled) setBootstrapped()
      })

    return () => {
      cancelled = true
    }
  }, [setSession, setBootstrapped])
}
